import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import VirtualizedTable from '../../../../../../components/common-table/VirtualizedTable';
import CollectDataTableItem from './CollectDataTableItem';
import Tr from '../../../../../../components/common-table/components/Tr';
import ThCheckbox from '../../../../../../components/common-table/components/ThCheckbox';
import Th from '../../../../../../components/common-table/components/Th';
import { toggleAllDomains } from '../../../../../../redux/sonar-management/sonarManagementReducer';
import ConfirmationModal from '../../../../../../components/confirmation-modal/ConfirmationModal';
import DeleteLabel from '../../../../../projects-list/components/DeleteLabel';
import { deleteFromDataset } from '../../../../../../redux/sonar-management/sonarManagementActions';

import scss from './CollectDataTable.module.scss';

const CollectDataTable = ({ disableActionButtons, disableTooltip, onEditStart }) => {
  const { t } = useTranslation('projects');
  const dispatch = useDispatch();

  const [selectedItem, setSelectedItem] = useState(null);

  const dataset = useSelector((state) => state.sonarManagement.dataset);
  const isLoading = useSelector((state) => state.sonarManagement.isDatasetLoading);
  const isAllSelected = useSelector((state) => state.sonarManagement.isAllSelected);

  const handleSelectAllDomain = () => {
    dispatch(toggleAllDomains());
  };

  const handleDeleteSingleItem = () => {
    dispatch(deleteFromDataset([selectedItem.id]));
    setSelectedItem(null);
  };

  const handleOpenDeleteModal = (item) => {
    setSelectedItem(item);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
  };

  return (
    <div className={scss.tableWrapper}>
      <VirtualizedTable
        content={dataset}
        isLoading={isLoading}
        renderBody={(item) => (
          <CollectDataTableItem
            key={item.count}
            data={item}
            onEdit={onEditStart}
            onDelete={handleOpenDeleteModal}
            disableActionButtons={disableActionButtons}
            disableTooltip={disableTooltip}
          />
        )}>
        <Tr extraClasses={scss.datasetTableHeader}>
          <ThCheckbox selected={isAllSelected} onSelect={handleSelectAllDomain} />
          <Th extraClasses='cell-rank'>#</Th>
          <Th isLeft extraClasses={scss.companyNameCell}>
            {t('company')}
          </Th>
          <Th isLeft extraClasses={scss.mediaCell}>
            Facebook
          </Th>
          <Th isLeft extraClasses={scss.mediaCell}>
            Instagram
          </Th>
          <Th isLeft extraClasses={scss.mediaCell}>
            Youtube
          </Th>
          {/* <Th isLeft>Trustpilot</Th> */}
          <Th isLeft extraClasses={scss.mediaCell}>
            Twitter
          </Th>
          <Th isLeft extraClasses={scss.mediaCell}>
            Tik-Tok
          </Th>
          {/* <Th isLeft extraClasses={scss.mediaCell}>
            LinkedIn
          </Th> */}
          <Th isLeft extraClasses={scss.cellActions} />
        </Tr>
      </VirtualizedTable>

      <ConfirmationModal
        isOpen={selectedItem}
        onClose={handleCloseModal}
        onCancel={handleCloseModal}
        onConfirm={handleDeleteSingleItem}
        subLabel={<DeleteLabel name={selectedItem?.brandCompany || selectedItem?.domain} />}
      />
    </div>
  );
};

export default CollectDataTable;
